import React from 'react';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import HomePage from './pages/HomePage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import SalesPage from './pages/SalesPage.jsx';
import ServicePage from './pages/ServicePage.jsx';
import PartsPage from './pages/PartsPage.jsx';
import VideosPage from './pages/VideosPage.jsx';
import FAQPage from './pages/FAQPage.jsx';
import Loader from "./components/loader.jsx";
import WhatsappButton from "./components/whatsapp.jsx";
import ScrollToTop from "./components/scrolltotop.jsx";
import Customers from "./pages/customer.jsx";
import TruckProductDetail from "./pages/productpage.jsx";
import NotFound from "./pages/notfound.jsx";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000); // show loader 2s
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;
  
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />

          <Route path="/sales" element={<SalesPage />} />
          <Route path="/service" element={<ServicePage />} />
          <Route path="/parts" element={<PartsPage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/customer" element={<Customers />} />
          <Route path="/trucks/:slug" element={<TruckProductDetail />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <WhatsappButton />
      </Layout>
    </Router>
    
  );
}

export default App;